export default "__VITE_ASSET__cef7d8ff__"